module.exports = __webpack_public_path__ + "media/images/countryrect/sy-b8df645ddc323c74e9ef45c3704aa14b.svg";